import request from '@/utils/request'

// 登录方法
export function login(username, password, captcha,uuid) {
  const data = {
    username,
    password,
    captcha,
    uuid
  }
  return request({
    url: '/api/login',
    method: 'post',
    params: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return request({
    url: '/api/login/user',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return request({
    url: '/api/logout',
    method: 'post'
  })
}

// 获取验证码
export function getCodeImg() {
  return request({
    url: '/api/captchaImage',
    method: 'get'
  })
}


// 获取微信登录二维码
export function getWxQrCode() {
  return request({
    url: '/api/login/wx/qrcode',
    method: 'get'
  })
}

// 获取微信登录二维码扫码结果
export function getWxQrCodeResult() {
  return request({
    url: '/api/login/wx/qrcode/result',
    method: 'get'
  })
}

